import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    travel: en,
  },
  fr: {
    travel: fr,
  },
  pt: {
    travel: pt,
  },
};
